export default __webpack_public_path__ + "static/media/School_3_2.b90496d6.png";